/**
 * 客戶來源下拉（顯示順序與分組；送後端為各選項的 label 字串）
 */

export const CUSTOMER_SOURCE_SELECT_OPTIONS = [
  { value: '18', label: '尚未確認' },
  { value: '11', label: '老客戶介紹' },
  {
    label: '介紹',
    options: [
      { value: '1', label: '親友介紹' },
      { value: '20', label: '醫生介紹' },
      { value: '19', label: '員工介紹' },
      { value: '21', label: '業外介紹' },
    ],
  },
  {
    label: '網路',
    options: [
      { value: '7', label: 'Youtube' },
      { value: '8', label: 'PTT' },
      { value: '9', label: 'Dcard狄卡' },
      { value: '12', label: 'Facebook' },
      { value: '13', label: 'Instagram' },
      { value: '14', label: 'Line' },
      { value: '15', label: 'Google' },
      { value: '16', label: 'Yahoo' },
      { value: '22', label: 'threads' },
      { value: '23', label: '小紅書' },
    ],
  },
  {
    label: '其他方式',
    options: [
      { value: '6', label: '代言人' },
      { value: '4', label: '電視媒體' },
      { value: '5', label: '平面廣告' },
      { value: '2', label: '傳單' },
      { value: '3', label: '路過' },
      { value: '10', label: '公車/計程車廣告' },
      { value: '17', label: '其他' },
    ],
  },
];

function flattenCustomerSourceLeafOptions() {
  const out = [];
  for (const item of CUSTOMER_SOURCE_SELECT_OPTIONS) {
    if (item.options) {
      out.push(...item.options);
    } else if (item.value != null) {
      out.push({ value: item.value, label: item.label });
    }
  }
  return out;
}

/**
 * value '1'～'23' → 現行 canonical label（與選單一致）
 * 等同早期各檔案內的 howDidYouKnowObj，集中維護。
 */
export const howDidYouKnowObj = Object.fromEntries(
  flattenCustomerSourceLeafOptions().map(({ value, label }) => [
    String(value),
    label,
  ])
);

/*
 * ===========================================================================
 * 歷史封存：以下為各檔曾 inline 的 howDidYouKnowObj（僅供對照後端舊字串，非執行程式碼）。
 * 實際送 API／正規化請用：howDidYouKnowObj、LEGACY_HOW_DID_YOU_KNOW_TO_CANONICAL、normalizeHowDidYouKnowFromApi。
 * ===========================================================================
 *
 * // --- src/pages/Helper/components/AddMember.js（舊版）---
 * // const howDidYouKnowObj = {
 * //   1: '親友介紹',
 * //   2: '傳單',
 * //   3: '路過',
 * //   4: '電視媒體',
 * //   5: '平面廣告',
 * //   6: '代言人',
 * //   7: 'Youtube',
 * //   8: 'PTT',
 * //   9: 'Dcard狄卡',
 * //   10: '公車/計程車',
 * //   11: '老客戶介紹',
 * //   12: '網路（Facebook）',
 * //   13: '網路（Instagram）',
 * //   14: '網路（Line）',
 * //   15: '網路（Google）',
 * //   16: '網路（Yahoo）',
 * //   17: '其他',
 * //   18: '尚未確認',
 * // };
 *
 * // --- 預約側欄已共用 PopAddMember；舊 AddMemberModal 已移除 ---
 * // const howDidYouKnowObj = {
 * //   1: "親友介紹",
 * //   2: "傳單",
 * //   3: "路過",
 * //   4: "電視媒體",
 * //   5: "平面廣告",
 * //   6: "代言人",
 * //   7: "Youtube",
 * //   8: "PTT",
 * //   9: "Dcard狄卡",
 * //   10: "公車/計程車",
 * //   11: "老客戶介紹",
 * //   12: "Facebook",
 * //   13: "Instagram",
 * //   14: "Line",
 * //   15: "Google",
 * //   16: "Yahoo",
 * //   17: "其他",
 * //   18: "尚未確認",
 * //   19: "員工介紹",
 * //   20: "醫生介紹",
 * //   21: "業外介紹",
 * // };
 *
 * // --- src/pages/Customer/Components/List/PopAddMember.js（舊版）---
 * // const howDidYouKnowObj = {
 * //   1: '親友介紹',
 * //   2: '傳單',
 * //   3: '路過',
 * //   4: '電視媒體',
 * //   5: '平面廣告',
 * //   6: '代言人',
 * //   7: 'Youtube',
 * //   8: 'PTT',
 * //   9: 'Dcard狄卡',
 * //   10: '公車/計程車',
 * //   11: '老客戶介紹',
 * //   12: 'Facebook',
 * //   13: 'Instagram',
 * //   14: 'Line',
 * //   15: 'Google',
 * //   16: 'Yahoo',
 * //   17: '其他',
 * //   18: '尚未確認',
 * //   19: '員工介紹',
 * //   20: '醫生介紹',
 * //   21: '業外介紹',
 * // };
 * ===========================================================================
 */

/**
 * 後端／舊版前端曾寫入的別名 → 現行 canonical label。
 * 涵蓋舊版：
 * - Helper/AddMember（12～16 為「網路（…）」、10 為公車/計程車）
 * - PopAddMember（含預約側欄；10 為公車/計程車；其餘 1～21 與現行 canonical 相同）
 * - 側欄／選單長文案「老客戶介紹（請填寫介紹人電話）」
 */
export const LEGACY_HOW_DID_YOU_KNOW_TO_CANONICAL = {
  '老客戶介紹（請填寫介紹人電話）': '老客戶介紹',
  '公車/計程車': '公車/計程車廣告',
  '網路（Youtube）': 'Youtube',
  '網路（PTT）': 'PTT',
  '網路（Dcard狄卡）': 'Dcard狄卡',
  '網路（Facebook）': 'Facebook臉書',
  '網路（Instagram）': 'Instagram(IG)',
  '網路（Line）': 'Line',
  '網路（Google）': 'Google',
  '網路（Yahoo）': 'Yahoo',
  '網路（threads）': 'threads',
  '網路（小紅書）': '小紅書',
  '網路（Threads）': 'threads',
  '小红书': '小紅書',
};

const CANONICAL_LABEL_SET = new Set(Object.values(howDidYouKnowObj));

/**
 * 將 API 或舊資料中的 how_did_you_know 轉成與選單一致的 canonical 字串。
 * 查無對照時原樣回傳（trim 後）。
 */
export function normalizeHowDidYouKnowFromApi(stored) {
  if (stored === null || stored === undefined) return stored;
  const s = String(stored).trim();
  if (s === '') return s;

  if (Object.prototype.hasOwnProperty.call(LEGACY_HOW_DID_YOU_KNOW_TO_CANONICAL, s)) {
    return LEGACY_HOW_DID_YOU_KNOW_TO_CANONICAL[s];
  }

  if (Object.prototype.hasOwnProperty.call(howDidYouKnowObj, s)) {
    return howDidYouKnowObj[s];
  }

  const lower = s.toLowerCase();
  if (lower === 'youtube') return 'Youtube';
  if (lower === 'threads') return 'threads';

  if (CANONICAL_LABEL_SET.has(s)) return s;

  return s;
}

export function findCustomerSourceOption(value) {
  if (value === undefined || value === null || value === '') return undefined;
  const key = String(value);
  for (const item of CUSTOMER_SOURCE_SELECT_OPTIONS) {
    if (item.options) {
      const found = item.options.find((o) => o.value === key);
      if (found) return found;
    } else if (item.value === key) {
      return item;
    }
  }
  return undefined;
}

/** API／表單的 how_did_you_know → Select 的 value（'1'～'23'） */
export function getCustomerSourceSelectValueFromStored(how) {
  if (how === null || how === undefined || how === '') return undefined;
  const flat = flattenCustomerSourceLeafOptions();
  const s = String(how).trim();
  const byValue = flat.find((o) => String(o.value) === s);
  if (byValue) return byValue.value;
  const norm = normalizeHowDidYouKnowFromApi(how);
  const byLabel = flat.find((o) => o.label === norm);
  return byLabel ? byLabel.value : undefined;
}

/** 將指定 value 的選項設為 disabled（避免重選目前客戶來源） */
export function mapCustomerSourceOptionsDisableValue(options, valueToDisable) {
  if (valueToDisable === undefined || valueToDisable === null || valueToDisable === '') {
    return options;
  }
  const key = String(valueToDisable);
  return options.map((item) => {
    if (item.options) {
      return {
        ...item,
        options: item.options.map((o) =>
          String(o.value) === key ? { ...o, disabled: true } : { ...o }
        ),
      };
    }
    if (item.value != null && String(item.value) === key) {
      return { ...item, disabled: true };
    }
    return { ...item };
  });
}

/** Select 的 value（'1'～'23'）→ canonical label */
export function getHowDidYouKnowLabel(value) {
  if (value === undefined || value === null || value === '') return undefined;
  return howDidYouKnowObj[String(value)];
}

/** 需填介紹人病歷號的客戶來源（舊長文案會 normalize 後等同老客戶介紹） */
export function isOldCustomerIntroducerSource(how) {
  if (how === null || how === undefined || how === '') return false;
  return normalizeHowDidYouKnowFromApi(how) === '老客戶介紹';
}

/** 客戶來源是否為「尚未確認」（含 API 以 id `18` 儲存，經 normalize 後為此標籤） */
export function isCustomerSourceUnconfirmed(how) {
  if (how === null || how === undefined || how === '') return true;
  if (String(how).trim() === '') return true;
  return normalizeHowDidYouKnowFromApi(how) === '尚未確認';
}
